import couponStores from "./coupon";

export default {
	...couponStores,
};
